import { injectGlobal } from 'styled-components';
import styledNormalize from 'styled-normalize'; // a package that injects normalize
import antdStyle from './antdStyle'; // css to overwrite anything form antd
import basicStyles from './basicStyles'; // our own custom top level css
import baseCssStyles from './baseCssStyles'; // from base-css module

injectGlobal`

    /* NORMALIZE STYLES */

    ${styledNormalize}

    /* BASIC STYLES */

    ${basicStyles}

    /* ANTD SPECIFIC OVERWRITES */

    ${antdStyle}

    ${baseCssStyles}


`;



// WEBPACK FOOTER //
// ./src/lib/theme/injectGlobal.js